import { render, staticRenderFns } from "./CourseManagers.vue?vue&type=template&id=6c97eebc&"
import script from "./CourseManagers.vue?vue&type=script&lang=js&"
export * from "./CourseManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports